import { IconCheck, IconArrowsSort } from '@tabler/icons-react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/Button';
import { Radio } from 'shared/Input';
import { DEFAULT_SORT_BY, SORT_BY_OPTIONS } from '../constants';
import { useSiteSelectorContext } from '../SiteSelectorContext';
import { PopoverForm } from './PopoverForm';

export const SortByPopover = () => {
    const { t } = useTranslation('navigation', {
        keyPrefix: 'site_selector.controls',
    });

    const { groupBy, sortBy, setSortBy } = useSiteSelectorContext();

    const [sortByLocal, setSortByLocal] = useState(sortBy);

    const onCloseSortBy = useCallback(() => {
        setSortByLocal(sortBy);
    }, [sortBy]);

    useEffect(() => {
        setSortByLocal(sortBy);
    }, [sortBy]);

    return (
        <PopoverForm
            dirty={sortBy !== DEFAULT_SORT_BY[groupBy]}
            icon={IconArrowsSort}
            label={t('sort_by.label')}
            onClose={onCloseSortBy}
            onSubmit={(event) => {
                event.preventDefault();
                setSortBy(sortByLocal);
            }}
        >
            {SORT_BY_OPTIONS[groupBy].map((sortByOption) => (
                <div key={sortByOption} className="mb-2">
                    <Radio
                        className="-mr-2"
                        id={sortByOption}
                        label={t(`sort_by.option.${sortByOption}`, {
                            groupBy,
                        })}
                        name="sortBy"
                        option={sortByOption}
                        value={sortByLocal}
                        onChange={(value) => setSortByLocal(value)}
                    />
                </div>
            ))}

            <Button className="ml-auto mt-4" outline size="xs" type="submit">
                {t('cta.apply')}
                <IconCheck />
            </Button>
        </PopoverForm>
    );
};
